import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateVideoMutationVariables = Types.Exact<{
  market: Types.Scalars['String']['input'];
  title: Types.Scalars['String']['input'];
  tags?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  videoThumbnailFileName: Types.Scalars['String']['input'];
  videoFileName: Types.Scalars['String']['input'];
  createdBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  updatedBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pubshingDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  stopDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateVideoMutation = { __typename?: 'Mutation', createTestimonial: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const CreateVideoDocument = gql`
    mutation CreateVideo($market: String!, $title: String!, $tags: [Int!], $videoThumbnailFileName: String!, $videoFileName: String!, $createdBy: String, $updatedBy: String, $pubshingDate: String, $stopDate: String) {
  createTestimonial(
    request: {market: $market, title: $title, tags: $tags, videoThumbnailFileName: $videoThumbnailFileName, videoFileName: $videoFileName, createdBy: $createdBy, updatedBy: $updatedBy, pubshingDate: $pubshingDate, stopDate: $stopDate}
  ) {
    count
    error
  }
}
    `;
export type CreateVideoMutationFn = Apollo.MutationFunction<CreateVideoMutation, CreateVideoMutationVariables>;

/**
 * __useCreateVideoMutation__
 *
 * To run a mutation, you first call `useCreateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoMutation, { data, loading, error }] = useCreateVideoMutation({
 *   variables: {
 *      market: // value for 'market'
 *      title: // value for 'title'
 *      tags: // value for 'tags'
 *      videoThumbnailFileName: // value for 'videoThumbnailFileName'
 *      videoFileName: // value for 'videoFileName'
 *      createdBy: // value for 'createdBy'
 *      updatedBy: // value for 'updatedBy'
 *      pubshingDate: // value for 'pubshingDate'
 *      stopDate: // value for 'stopDate'
 *   },
 * });
 */
export function useCreateVideoMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoMutation, CreateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoMutation, CreateVideoMutationVariables>(CreateVideoDocument, options);
      }
export type CreateVideoMutationHookResult = ReturnType<typeof useCreateVideoMutation>;
export type CreateVideoMutationResult = Apollo.MutationResult<CreateVideoMutation>;
export type CreateVideoMutationOptions = Apollo.BaseMutationOptions<CreateVideoMutation, CreateVideoMutationVariables>;